import React from "react";
import Messages from "./Messages";
import CustomerGreetings from "./CustomerGreetings";
import MainbarCards from "./MainbarCards";
import MainbarCards1 from "./MainbarCards1";
import EmbeddedChart from "./EmbeddedChart";
import ThirdPartyChart2 from "./ThirdPartyChart2";

const Mainbar = () => {
  return (
    <div className="">
      <div className="flex flex-row ml-1">
        <div className="w-1/3 ">
          <CustomerGreetings />
          <Messages />
        </div>
        <div className="ml-5 mb-5 mt-5 w-1/3">
          <EmbeddedChart />
          {/* <ThirdPartyChart /> */}
        </div>
        <div className="w-1/3  grid place-items-center">
          <ThirdPartyChart2 />
        </div>
      </div>
      <MainbarCards />
      <MainbarCards1 />
    </div>
  );
};

export default Mainbar;
